// ===============================
// Admin AllBookings.js (RESPONSIVE + SCROLLABLE GRID + UNBLOCK)
// ===============================

import React, { useEffect, useMemo, useRef, useState } from "react";
import { FaCalendarAlt, FaListUl } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./adminstyle.css";
const API = process.env.REACT_APP_API_BASE || "https://api.getfitindia.in/api";





/* -------------------------------- */
const formatTime = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":");
  const hour = parseInt(h, 10);
  return `${hour % 12 || 12}:${m} ${hour >= 12 ? "PM" : "AM"}`;
};

const parseMinutes = (t) => {
  if (!t) return 0;
  const [h, m] = t.split(":").map(Number);
  return h * 60 + (m || 0);
};

const formatDateYMD = (d) => {
  if (!(d instanceof Date)) d = new Date(d);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(d.getDate()).padStart(2, "0")}`;
};

const normalizeName = (s) => (s || "").toLowerCase().replace(/\s+/g, "");

const getAuthHeader = () => {
  const adminToken = localStorage.getItem("token");
  const courtOwnerToken = localStorage.getItem("courtOwnerToken");

  // use court owner token first (because blockslots API requires it)
  const token = courtOwnerToken || adminToken;

  return token ? { Authorization: `Bearer ${token}` } : {};
};


// ✅ helper like in court owner
const isBlocked = (b) =>
  b?._isBlocked === true ||
  b?.status === "blocked" ||
  b?.type === "blocked" ||
  b?.isBlocked === true;

/* -------------------------------- */
const CalendarTrigger = React.forwardRef(({ onClick }, ref) => (
  <button ref={ref} onClick={onClick} className="date-trigger">
    <FaCalendarAlt />
  </button>
));

/* -------------------------------- */
export default function AllBookings() {
  const [owners, setOwners] = useState([]);
  const [venues, setVenues] = useState([]);
  const [courts, setCourts] = useState([]);

  const [selectedOwner, setSelectedOwner] = useState("");
  const [selectedVenue, setSelectedVenue] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [viewMode, setViewMode] = useState("list");

  const [bookings, setBookings] = useState([]);
  const [blockedSlots, setBlockedSlots] = useState([]);

  const monthStripRef = useRef(null);
  const activeChipRef = useRef(null);

  const slotHeight = 62;
  const timeSlots = Array.from({ length: 24 }, (_, i) => i);
  const timeScrollRef = useRef(null);

// - ------------------------------

const [isDesktop, setIsDesktop] = useState(
  typeof window !== "undefined" ? window.innerWidth >= 769 : false
);
useEffect(() => {
  if (!timeScrollRef.current || viewMode !== "grid") return;

  const now = new Date();
  const currentHour = now.getHours(); // 0–23
  const scrollTo = currentHour * slotHeight; // px position

  timeScrollRef.current.scrollTo({
    top: scrollTo,
    behavior: "smooth",
  });
}, [viewMode, selectedVenue, selectedDate, isDesktop]);

useEffect(() => {
  const handleResize = () => {
    setIsDesktop(window.innerWidth >= 769);
  };
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

// -----------------------------------



  /* --------------------------------
      Inject Global CSS (responsive + scroll)
  -------------------------------- */
  useEffect(() => {
    const css = `
      :root{
        --navy:#0C295F;
        --orange:#FF5A00;
        --line:#E6EBF2;
        --soft:#EAEFF5;
      }

      /* Wrapper fills viewport height on right side */
      .allbookings-wrapper{
        position:relative;
        width:100%;
         height:calc(100vh - 60px); /* 60px ≈ top navbar height; tweak if needed */
        display:flex;
        flex-direction:column;
        overflow:hidden;           /* stop page/body scroll, only inner scrolls */
      }

      .allbookings-header{
        flex-shrink:0;
        padding-bottom:8px;
      }

      /* Only this scrolls (month strip + list or calendar) */
      .allbookings-scroll{
        flex:1;
        min-height:0;
        overflow-y:auto;
        padding-bottom:24px;
      }

      .top-controls {
        display:flex;
        gap:10px;
        flex-wrap:wrap;
        margin-bottom:15px;
      }

      .select-box {
        padding:8px 10px;
        border-radius:10px;
        border:1px solid var(--line);
        background:#fff;
        font-size:14px;
      }

      .date-trigger{
        width:38px;
        height:38px;
        border:1px solid var(--line);
        border-radius:10px;
        background:#fff;
        display:flex;
        align-items:center;
        justify-content:center;
      }

      .toggle-btn{
        padding:8px 14px;
        border-radius:10px;
        border:1px solid var(--line);
        background:#fff;
        font-weight:700;
        display:flex;
        align-items:center;
        gap:6px;
        font-size:14px;
      }

      /* Month strip */
      .week-strip{
        display:flex;
        gap:8px;
        overflow-x:auto !important;
        white-space:nowrap;
        scrollbar-width:none;
        padding-bottom:12px;
        margin-bottom:10px;
      }
      .week-strip::-webkit-scrollbar{ display:none; }

      .chip{ border:0;background:none; cursor:pointer; }
      .badge{
        width:42px;
        height:42px;
        border-radius:50%;
        display:flex;
        align-items:center;
        justify-content:center;
        background:var(--soft);
        font-weight:700;
        color:var(--navy);
      }
      .chip.active .badge{
        background:var(--orange);
        color:#fff;
      }

      /* ====== CALENDAR VIEW ====== */

      .cal-card{
        background:#fff;
        border:1px solid var(--line);
        border-radius:14px;
        overflow:hidden;
        box-shadow:0 4px 10px rgba(12,41,95,0.06);
        width:100%;
      }

      .time-col{
        width:64px;
        border-right:1px solid var(--line);
        flex-shrink:0;
      }

      .time-head{
        background:#0C295F;
        color:#fff;
        height:65px;
        display:flex;
        align-items:center;
        justify-content:center;
        font-size:11px;
        font-weight:700;
        border-bottom:1px solid #1f2e52;
      }

      .time-cell{
        height:${slotHeight}px;
        display:flex;
        align-items:flex-start;
        justify-content:center;
        padding-top:8px;
        font-size:12px;
        color:#0C295F;
        border-top:1px solid #f1f5f9;
      }

      .courts-head{
        display:flex;
        width:max-content;
        border-bottom:1px solid var(--line);
      }

      .cols{
        position:relative;
        display:flex;
        width:max-content;
      }

      .court-h{
        background:#0C295F;
        color:#fff;
        text-align:center;
        padding:12px 0;
        border-left:1px solid #1f2e52;
        font-weight:600;
        flex:0 0 140px;
        min-width:140px;
        font-size:13px;
      }
      .court-h small{
        display:block;
        font-size:11px;
        opacity:.9;
      }

      .col{
        position:relative;
        border-left:1px solid var(--line);
        height:${slotHeight * 24}px;
        flex:0 0 140px;
        min-width:140px;
      }

      .grid-line{
        position:absolute;
        left:0;
        right:0;
        border-top:1px solid #f1f5f9;
      }

      .slot{
        position:absolute;
        left:4px;
        right:4px;
        border-radius:8px;
        padding:6px;
        font-weight:700;
        font-size:11px;
        box-shadow:0 1px 2px rgba(0,0,0,.06);
        display:flex;
        flex-direction:column;
        justify-content:center;
        box-sizing:border-box;
      }

      .slot.booked{
        background:#007d2e;
        border:1px solid #B6E3C9;
        color:white;
      }

      .slot.blocked{
        background:#ff5a00;
        border:1px solid #ffffff;
        color:#FFFFFF;
        cursor:pointer; /* clickable for unblock */
      }

      .slot .sub{
        font-size:10px;
        opacity:.9;
        margin-top:2px;
      }

      .courts-scroll{
        overflow-x:auto;
        width:100%;
        -webkit-overflow-scrolling:touch;
      }

      /* ===== Responsive tweaks ===== */

      @media (max-width: 768px){
        .allbookings-wrapper{
          height:calc(100vh - 54px);
        }

        .top-controls{
          flex-direction:column;
          align-items:stretch;
        }

        .select-box,
        .toggle-btn{
          width:100%;
        }

        .date-trigger{
          width:100%;
          justify-content:center;
        }

        .cal-card{
          border-radius:10px;
        }

        .time-head{
          font-size:10px;
        }

        .time-cell{
          font-size:11px;
        }
      }

      @media (min-width: 1200px){
        .courts-head{
          width:100%;
        }
        .cols{
          width:100%;
        }
        .court-h,
        .col{
          flex:1 0 160px;
        }
      }
        .react-datepicker{
    margin-left: 184px;
}
    .react-datepicker-wrapper {
    width: 26%;
  }
    `;

    const style = document.createElement("style");
    style.innerHTML = css;
    document.head.appendChild(style);

    return () => document.head.removeChild(style);
  }, [slotHeight]);

  /* --------------------------------
      Fetch Owners
  -------------------------------- */
  useEffect(() => {
    (async () => {
      const res = await fetch(`${API}/admin/owners`, {
        headers: getAuthHeader(),
      });
      const data = await res.json();
      setOwners(data?.owners || []);
    })();
  }, []);

  /* --------------------------------
      Fetch Venues
  -------------------------------- */
  /* --------------------------------
    Fetch Venues (SAFE ALWAYS ARRAY)
-------------------------------- */
useEffect(() => {
  if (!selectedOwner) {
    setVenues([]);
    return;
  }

  (async () => {
    try {
      const res = await fetch(`${API}/admin/owners/${selectedOwner}/venues`, {
        headers: getAuthHeader(),
      });

      const data = await res.json();
      console.log("VENUE RAW RESPONSE →", data);

      let venueList = [];

      // 💯 FULL PROTECTION, backend can return anything
      if (Array.isArray(data)) {
        venueList = data;
      } else if (Array.isArray(data?.venues)) {
        venueList = data.venues;
      } else if (Array.isArray(data?.data)) {
        venueList = data.data;
      } else if (Array.isArray(data?.results)) {
        venueList = data.results;
      } else {
        console.error("❌ Venues response invalid:", data);
      }

      setVenues(venueList);
    } catch (err) {
      console.error("❌ Failed to load venues", err);
      setVenues([]); // fallback ALWAYS array
    }
  })();
}, [selectedOwner]);


  /* --------------------------------
      Fetch Courts + Bookings
  -------------------------------- */
  useEffect(() => {
    if (!selectedVenue) {
      setCourts([]);
      setBookings([]);
      return;
    }

    (async () => {
      const courtRes = await fetch(`${API}/slots/${selectedVenue}/courts`, {
        headers: getAuthHeader(),
      });
      const courtsData = await courtRes.json();

      const mapped = courtsData.map((c) => ({
        _id: c._id,
        courtName: c.courtName || c.name || "Court",
      }));
      setCourts(mapped);

      const all = await Promise.all(
        mapped.map((c) =>
          fetch(`${API}/slots/${selectedVenue}/${c._id}/bookings`, {
            headers: getAuthHeader(),
          }).then((r) => r.json())
        )
      );

      setBookings(all.flat());
    })();
  }, [selectedVenue]);

  /* --------------------------------
      BLOCKED SLOTS Fetch (Grid View)
  -------------------------------- */
  useEffect(() => {
    if (!selectedVenue || viewMode !== "grid") return setBlockedSlots([]);

    const dateStr = formatDateYMD(selectedDate);

    (async () => {
      const list = await Promise.all(
        courts.map(async (c) => {
          try {
            const res = await fetch(
              `${API}/courtowner/blockslots/${c._id}?date=${dateStr}`,
              { headers: getAuthHeader() }
            );
            if (!res.ok) return [];

            const data = await res.json();
            // keep server _id, just mark as blocked
            return data.map((s) => ({
              ...s,
              _isBlocked: true,
            }));
          } catch {
            return [];
          }
        })
      );

      setBlockedSlots(list.flat());
    })();
  }, [selectedVenue, courts, selectedDate, viewMode]);

  /* --------------------------------
      Filter Bookings List View
  -------------------------------- */
  const filteredBookings = useMemo(() => {
    return bookings.filter((b) => {
      const d = new Date(b.date);
      return (
        d.getFullYear() === selectedDate.getFullYear() &&
        d.getMonth() === selectedDate.getMonth() &&
        d.getDate() === selectedDate.getDate()
      );
    });
  }, [bookings, selectedDate]);

  const uniqueBookings = useMemo(() => {
    const m = new Map();
    filteredBookings.forEach((b) => {
      const cid = b.courtId?._id || b.courtId || normalizeName(b.courtName);
      const key = `${cid}|${b.startTime}|${b.endTime}`;
      if (!m.has(key)) m.set(key, b);
    });
    return [...m.values()];
  }, [filteredBookings]);

  /* --------------------------------
      Month Strip
  -------------------------------- */
  const monthDays = useMemo(() => {
    const y = selectedDate.getFullYear();
    const m = selectedDate.getMonth();
    const arr = [];

    for (let d = new Date(y, m, 1); d.getMonth() === m; d.setDate(d.getDate() + 1))
      arr.push(new Date(d));

    return arr;
  }, [selectedDate]);

  useEffect(() => {
    const strip = monthStripRef.current;
    const active = activeChipRef.current;

    if (!strip || !active) return;

    strip.scrollTo({
      left: active.offsetLeft - strip.clientWidth / 2,
      behavior: "smooth",
    });
  }, [selectedDate, monthDays.length]);

  /* --------------------------------
      UNBLOCK HANDLER (Admin)
  -------------------------------- */
  const handleUnblock = async (slot) => {
    if (!slot?._id) return;

    const ok = window.confirm(
      `Unblock this slot?\n${formatTime(slot.startTime)} – ${formatTime(
        slot.endTime
      )}${slot?.reason ? `\nReason: ${slot.reason}` : ""}`
    );
    if (!ok) return;

    try {
      const res = await fetch(`${API}/courtowner/blockslots/${slot._id}`, {
        method: "DELETE",
        headers: {
          ...getAuthHeader(),
        },
      });

      if (!res.ok) throw new Error("Failed to unblock slot");

      // Remove from local blocked state
      setBlockedSlots((prev) => prev.filter((b) => b._id !== slot._id));
    } catch (err) {
      alert(err.message || "Failed to unblock slot");
    }
  };

  /* --------------------------------
      UI START
  -------------------------------- */
  return (
<>
    
 {/* HEADER */}
      <div className="bg-[#0f2250] text-white sticky top-0 z-20">
        <div className="max-w-6xl  px-4 py-4">
       <h1 className="text-lg font-semibold ms-12 sm:ms-0 mt-1">
    All Bookings
</h1>

        </div>
      </div>
    <div className="allbookings-wrapper  px-4 py-6">
      {/* HEADER + FILTERS (fixed inside content) */}
      <div className="allbookings-header">
     
 
        <div className="top-controls">
       <div className="select-container gap-2 md:flex">

          <select
            className="select-box my-2 sm:my-0 h-9 rounded-lg text-sm border border-gray-300 px-3"
            value={selectedOwner}
            onChange={(e) => {
              setSelectedOwner(e.target.value);
              setSelectedVenue("");
            }}
          >
            <option value="">Select Court Owner</option>
            {owners.map((o) => (
              <option key={o._id} value={o._id}>
                {o.name} — {o.mobile}
              </option>
            ))}
          </select>

          <select
            className="select-box h-9 rounded-lg text-sm border border-gray-300 px-3"
            value={selectedVenue}
            onChange={(e) => setSelectedVenue(e.target.value)}
          >
            <option value="">Select Venue</option>
          {(venues || []).map((v) => (

              <option key={v._id} value={v._id}>
                {v.name}
              </option>
            ))}
          </select>
</div>
 <div className="flex items-center gap-3">
          <DatePicker
            selected={selectedDate}
            onChange={(d) => setSelectedDate(d)}
            customInput={<CalendarTrigger />} style={{
   
}}
          />

          <button
            className="toggle-btn h-9 rounded-lg text-sm border border-gray-300 px-3 w-full"
            onClick={() => setViewMode((p) => (p === "list" ? "grid" : "list"))}
          >
            <FaListUl />
            {viewMode === "list" ? "Calendar View" : "List View"}
          </button>
</div>
        </div>
      </div>

      {/* SCROLLABLE CONTENT AREA (month strip + list/grid) */}
      <div className="allbookings-scroll">
        {/* MONTH STRIP */}
        {selectedVenue && (
          <div className="week-strip" ref={monthStripRef}>
            {monthDays.map((d, i) => {
              const active = d.toDateString() === selectedDate.toDateString();
              return (
                <button
                  key={i}
                  className={`chip ${active ? "active" : ""}`}
                  onClick={() => setSelectedDate(new Date(d))}
                  ref={active ? activeChipRef : null}
                >
                  <div className="badge">{d.getDate()}</div>
                </button>
              );
            })}
          </div>
        )}

        {/* LIST VIEW */}
        {viewMode === "list" && selectedVenue && (
          <div>
            {uniqueBookings.length === 0 ? (
              <p style={{ textAlign: "center", color: "#888" }}>
                No bookings for selected date.
              </p>
            ) : (
              uniqueBookings.map((b) => {
                const payer = b.userId?.name || "User";
                const phone =
                  b.userId?.mobile || b.user?.phone || b.user?.mobile || "";

                const venueText =
                  venues.find((v) => v._id === selectedVenue)?.name || "Venue";

                const courtText = b.courtName || "Court";

                return (
                  <div
                    key={b._id}
                    style={{
                      background: "#fff",
                      borderRadius: 16,
                      padding: "18px 24px",
                      marginBottom: 18,
                      boxShadow: "0 4px 10px rgba(12,41,95,0.08)",
                      border: "1px solid #E6EBF2",
                    }}
                  >
                    {/* HEADER */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                        <span
                          style={{
                            background: "#16A34A",
                            color: "#fff",
                            padding: "4px 12px",
                            borderRadius: 20,
                            fontWeight: 700,
                            fontSize: 12,
                          }}
                        >
                          PAID
                        </span>
                        <span
                          style={{
                            border: "1.5px solid #94A3B8",
                            padding: "4px 12px",
                            borderRadius: 20,
                            fontWeight: 700,
                            fontSize: 12,
                          }}
                        >
                          {b.razorpay_payment_id ? "ONLINE" : "OFFLINE"}
                        </span>
                      </div>

                      <div
                        style={{
                          fontSize: 12,
                          color: "#666",
                          fontWeight: 700,
                          marginLeft: 10,
                        }}
                      >
                        ID: {b.bookingId || b._id?.slice(-8)?.toUpperCase()}
                      </div>
                    </div>

                    {/* DATE + TIME */}
                    <div
                      style={{
                        marginTop: 12,
                        display: "flex",
                        justifyContent: "space-between",
                        color: "#0C295F",
                        fontWeight: 800,
                        flexWrap: "wrap",
                        rowGap: 4,
                      }}
                    >
                      <div>
                        {new Date(b.date).toLocaleDateString("en-GB", {
                          weekday: "short",
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })}
                      </div>
                      <div>
                        {formatTime(b.startTime)} – {formatTime(b.endTime)}
                      </div>
                    </div>

                    {/* VENUE + COURT */}
                    <div
                      style={{
                        marginTop: 8,
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        rowGap: 4,
                      }}
                    >
                      <div
                        style={{
                          fontWeight: 800,
                          fontSize: 15,
                          color: "#0C295F",
                        }}
                      >
                        {venueText}
                      </div>

                      <div style={{ fontSize: 13, color: "#666" }}>
                        Court {courtText}
                      </div>
                    </div>

                    <div
                      style={{
                        height: 1,
                        background: "#EDF2F7",
                        margin: "14px 0",
                      }}
                    />

                    {/* AMOUNTS */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontWeight: 800,
                        fontSize: 14,
                        color: "#0C295F",
                        flexWrap: "wrap",
                        rowGap: 8,
                      }}
                    >
                      <div>
                        <div
                          style={{
                            fontSize: 12,
                            color: "#666",
                            marginBottom: 2,
                          }}
                        >
                          Amount Paid
                        </div>
                        ₹ {b.price || b.amountPaid || 0}
                      </div>

                      <div>
                        <div
                          style={{
                            fontSize: 12,
                            color: "#666",
                            marginBottom: 2,
                          }}
                        >
                          Total
                        </div>
                        <span style={{ color: "#FF5A00" }}>
                          ₹ {b.total || b.price || 0}
                        </span>
                      </div>
                    </div>

                    <div
                      style={{
                        height: 1,
                        background: "#EDF2F7",
                        margin: "14px 0",
                      }}
                    />

                    {/* FOOT : USER + CALL */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        rowGap: 8,
                      }}
                    >
                      <div>
                        <div
                          style={{
                            fontWeight: 800,
                            color: "#0C295F",
                            fontSize: 14,
                          }}
                        >
                          {payer}
                        </div>

                        <div style={{ fontSize: 12, color: "#555" }}>
                          {phone}
                        </div>
                      </div>

                      {phone && (
                        <a
                          href={`tel:${phone}`}
                          style={{
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            background: "#0C295F",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 18,
                          }}
                        >
                          📞
                        </a>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        )}

        {/* GRID VIEW – scrollable calendar */}
{/* GRID VIEW – scrollable calendar */}
{viewMode === "grid" && selectedVenue && (
  <div style={{ marginTop: 10 }}>
    <div className="cal-card" style={{ marginTop: 6 }}>
      <div
        style={{
          display: "flex",
          width: "100%",
        }}
      >
        {/* Time Column */}
        <div className="time-col">
          <div className="time-head">Time</div>
          {timeSlots.map((hour) => (
            <div key={hour} className="time-cell">
              {(hour % 12 || 12).toString().padStart(2, "0")}:00{" "}
              {hour >= 12 ? "PM" : "AM"}
            </div>
          ))}
        </div>

        {/* Courts + Columns (scrollable horizontally) */}
       <div
  className="courts-scroll"
  ref={timeScrollRef}
  style={{
    flex: 1,
    overflowX: "auto",
    overflowY: "auto",
    width: "100%",
  }}
>

        
          {/* Courts header */}
          <div
            className="courts-head"
            style={
              isDesktop
                ? {
                    height: "66px",
                    width: "100%",
                    display: "grid",
                    gridTemplateColumns: `repeat(${
                      courts.length || 1
                    }, minmax(0, 1fr))`,
                  }
                : { height: "66px" } // 🔁 mobile & tab (<769px) = original CSS
            }
          >
            {courts.length > 0 ? (
              courts.map((c) => (
                <div
                  key={c._id}
                  className="court-h"
                  title={`${c.courtName} – Full Court`}
                  style={
                    isDesktop
                      ? {
                          padding: "8px 10px",
                          textAlign: "center",
                          borderRight: "1px solid rgba(255,255,255,0.15)",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }
                      : undefined
                  }
                >
                  {c.courtName}
                  <small>Full Court</small>
                </div>
              ))
            ) : (
              <div
                style={{
                  padding: "10px 0",
                  textAlign: "center",
                  width: "100%",
                  color: "#6b7280",
                }}
              >
                No Courts Found
              </div>
            )}
          </div>

          {/* Columns + slots */}
          <div
            className="cols"
            style={
              isDesktop
                ? {
                    display: "grid",
                    gridTemplateColumns: `repeat(${
                      courts.length || 1
                    }, minmax(0, 1fr))`,
                    width: "100%",
                    position: "relative",
                    background: "#fff",
                  }
                : undefined // 🔁 <769px use your old CSS
            }
          >
            {courts.map((c) => (
              <div
                key={c._id}
                className="col"
                style={
                  isDesktop
                    ? {
                        position: "relative",
                        borderRight: "1px solid #f3f4f6",
                        minHeight: timeSlots.length * slotHeight,
                      }
                    : undefined
                }
              >
                {timeSlots.map((hour) => (
                  <div
                    key={`line-${c._id}-${hour}`}
                    className="grid-line"
                    style={
                      isDesktop
                        ? {
                            position: "absolute",
                            top: `${hour * slotHeight}px`,
                            left: 0,
                            right: 0,
                            height: 1,
                            background: "#f3f4f6",
                          }
                        : {
                            top: `${hour * slotHeight}px`,
                          }
                    }
                  />
                ))}

                {[...uniqueBookings, ...blockedSlots]
                  .filter((b) => {
                    const d = new Date(b.date);
                    return (
                      d.getFullYear() === selectedDate.getFullYear() &&
                      d.getMonth() === selectedDate.getMonth() &&
                      d.getDate() === selectedDate.getDate()
                    );
                  })
                  .filter((b) => {
                    const id = b.courtId?._id || b.courtId;
                    return (
                      id === c._id ||
                      normalizeName(b.courtName) === normalizeName(c.courtName)
                    );
                  })
                  .map((b, i) => {
                    const startMin = parseMinutes(b.startTime);
                    const endMin = parseMinutes(b.endTime);
                    const durationHrs = Math.max(
                      (endMin - startMin) / 60,
                      0.25
                    );
                    const topPx = (startMin / 60) * slotHeight;

                    const blocked = isBlocked(b);

                    const title = blocked
                      ? "Bulk slots blocked"
                      : `Slot booked by ${
                          b.userId?.name || b.user?.name || "User"
                        }`;

                    const subtitle = blocked
                      ? b.reason ||
                        `${formatTime(b.startTime)} – ${formatTime(
                          b.endTime
                        )}`
                      : `${formatTime(b.startTime)} – ${formatTime(
                          b.endTime
                        )}`;

                    return (
                      <div
                        key={`${b._id || i}-${b.startTime}-${b.endTime}-${
                          blocked ? "blk" : "bkd"
                        }`}
                        className={`slot ${blocked ? "blocked" : "booked"}`}
                      style={
  isDesktop
    ? {
        position: "absolute",
        left: 6,
        right: 6,
        top: `${topPx}px`,
        height: `${slotHeight * durationHrs - 4}px`,
        background: blocked ? "#ff5a00" : "#ff5a00",
        color: "#fff",
        borderRadius: 8,
        padding: "8px 10px",
        fontSize: 12,
        fontWeight: 700,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
        cursor: blocked ? "pointer" : "default",
        overflow: "hidden",
      }
    : {
        top: `${topPx}px`,
        height: `${slotHeight * durationHrs - 4}px`,
      }
}

                        title={
                          blocked
                            ? `Blocked: ${
                                b.reason || "—"
                              }\n${formatTime(
                                b.startTime
                              )} – ${formatTime(
                                b.endTime
                              )}\nClick to Unblock`
                            : `Booked by ${
                                b.userId?.name || b.user?.name || "User"
                              }\n${formatTime(
                                b.startTime
                              )} – ${formatTime(b.endTime)}`
                        }
                        onClick={
                          blocked ? () => handleUnblock(b) : undefined
                        }
                      >
                        <div>{title}</div>
                        {/* <div className="sub">{subtitle}</div> */}
                      </div>
                    );
                  })}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
)}



        {/* NOTHING SELECTED */}
        {!selectedVenue && (
          <p style={{ marginTop: 24, color: "#888", fontWeight: 600 }}>
            Select owner & venue to view bookings.
          </p>
        )}
      </div>
    </div>
    </>
  );
}

